var map = {
	"./avizva.jpeg": [
		8442,
		1,
		442
	],
	"./blog-app.png": [
		2453,
		1,
		453
	],
	"./development.png": [
		5695,
		1,
		695
	],
	"./favicon.png": [
		4775,
		1,
		775
	],
	"./hashedin.webp": [
		1721,
		1,
		721
	],
	"./jamia.png": [
		5917,
		1,
		917
	],
	"./jnvst.png": [
		2897,
		1,
		897
	],
	"./passportpic.jpg": [
		7361,
		1
	],
	"./pizza-app.png": [
		2416,
		1,
		416
	],
	"./responsive-web.webp": [
		7171,
		1,
		171
	],
	"./resume_wasim.pdf": [
		5303,
		9,
		303
	],
	"./stellarIndia.jpg": [
		1459,
		1,
		459
	],
	"./title-icon-96.png": [
		3280,
		1,
		280
	],
	"./web-design.jpg": [
		887,
		1,
		887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 585;
module.exports = webpackAsyncContext;